import CONSTANTS from '@utilities/constants'

const AUCTION = 'AUCTION'

const PRIMARY_LINKS = [
  { name: 'live auctions', link: '/category/all/1', categories: [AUCTION] },
  {
    name: 'Equipment \n auctions',
    link: '/mnr-auctions/all/1',
    categories: [AUCTION],
  },
  {
    name: 'Truckloads',
    link: '/category/truckloads/1',
    categories: [AUCTION],
  },
]

const SECONDARY_LINKS = [
  {
    name: 'Past Auctions',
    link: '/past-auctions/all/1',
    categories: [AUCTION],
  },
  {
    name: 'Auction FAQ',
    link: CONSTANTS.LINKS.AUCTION_FAQ,
    categories: [AUCTION],
  },
  { name: 'Terms & Conditions', link: '/terms' },
  { name: 'Privacy Policy', link: '/privacy-policy' },
  {
    name: 'Contact',
    link: CONSTANTS.LINKS.AUCTION_CONTACT,
  },
  {
    name: 'Careers',
    link: CONSTANTS.LINKS.CAREERS,
  },
]

export const C = {
  AUCTION,
  PRIMARY_LINKS,
  SECONDARY_LINKS,
  AUCTION_FAQ: CONSTANTS.LINKS.AUCTION_FAQ,
  AUCTION_CONTACT: CONSTANTS.LINKS.AUCTION_CONTACT,
}

export const filterLinks = ({ categories }: { categories?: string[] }) => {
  if (!categories) return true
  return categories.some((category) => AUCTION.includes(category))
}
